<template>
  <div class="md-table-cell-container">
    <router-link :to="'/progress-report/' + id + '/detail'" target="_blank">
      <md-button class="md-just-icon md-warning md-simple table-action">
        <md-tooltip md-direction="top">{{ $t("common.view") }}</md-tooltip>
        <md-icon>{{
          isInputter && studentAssigned.includes(item.student_id)
            ? "edit"
            : "visibility"
        }}</md-icon>
      </md-button>
    </router-link>
    <md-button
      class="md-just-icon md-danger md-simple table-action"
      @click="triggerConfirmDeletePR()"
    >
      <md-tooltip md-direction="top">{{ $t("common.delete") }}</md-tooltip>
      <md-icon>close</md-icon>
    </md-button>
  </div>
</template>

<script>
import { getId } from "@/helpers/utils";
import { mapGetters, mapState } from "vuex";

export default {
  props: ["item"],
  computed: {
    ...mapState("user", ["studentAssigned"]),
    ...mapGetters("user", ["info"]),
    isInputter() {
      return this.info?.inputterOrReviewDetail?.authorized === "Inputter";
    },
    id() {
      return getId(this.item);
    }
  },
  inject: ["confirmDeletePR"],
  data() {
    return {
      getId
    };
  },
  methods: {
    triggerConfirmDeletePR() {
      this.confirmDeletePR(this.item);
    }
  }
};
</script>

<style lang="scss" scoped>
.table-action {
  padding: 0 5px;
  margin: 0 2px;
}
</style>
